module.exports = __webpack_public_path__ + "img/04031000.0f1eb75d.png";